import { t } from "@/i18n-js/instance";

const i18nRoot = "eoy_recap_2025.sections.hero";

interface HeroProps {
  accentColor?: string;
}

export const Hero = ({ accentColor = "#2CAE6E" }: HeroProps) => (
  <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
    <div
      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-[496px] rounded-[496px] blur-[150px]"
      style={{ backgroundColor: accentColor }}
    />

    <div className="relative z-10 flex flex-col items-center justify-center px-4 text-center">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-8">
        {t([i18nRoot, "title"])}
      </h1>

      <div className="relative mb-12">
        <div
          className="absolute text-[120px] md:text-[180px] lg:text-[240px] font-black leading-none tracking-tight translate-x-2 translate-y-2"
          style={{ color: accentColor }}
        >
          {t([i18nRoot, "year"])}
        </div>

        <div className="relative text-[120px] md:text-[180px] lg:text-[240px] font-black text-white leading-none tracking-tight">
          {t([i18nRoot, "year"])}
        </div>
      </div>

      <p className="text-xl md:text-2xl lg:text-3xl text-white mb-12 max-w-3xl">
        {t([i18nRoot, "description"])}
      </p>

      <button
        type="button"
        className="px-8 py-3 text-lg font-semibold text-white rounded-full hover:shadow-lg transition-all duration-300 hover:scale-105"
        style={{ backgroundColor: accentColor }}
      >
        {t([i18nRoot, "cta"])}
      </button>
    </div>
  </div>
);
